import { render, staticRenderFns } from "./UserAccRemNotification.vue?vue&type=template&id=ee03a032&scoped=true&"
import script from "./UserAccRemNotification.vue?vue&type=script&lang=js&"
export * from "./UserAccRemNotification.vue?vue&type=script&lang=js&"
import style0 from "./UserAccRemNotification.vue?vue&type=style&index=0&id=ee03a032&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee03a032",
  null
  
)

export default component.exports